import { render, staticRenderFns } from "./FolderUpdate.vue?vue&type=template&id=e2f5841a"
import script from "./FolderUpdate.vue?vue&type=script&lang=ts"
export * from "./FolderUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports